<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar/>
        <!-- /#sidebar-wrapper -->
        <!-- Page Content -->
        <div id="page-content-wrapper">
          <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
            <div>
              <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
              </button>

              <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
              </button>
            </div>
            <div class="d-flex">
              <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
              <p class="text-muted mb-0 hover-cursor" @click="toOrderPage">&nbsp;Order&nbsp;</p>
              <p class="text-primary mb-0 hover-cursor">/&nbsp;extend</p>
            </div>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ admin }}
                  </a>
                  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                    <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                  </div>
                </li>
              </ul>
            </div>
          </nav>
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12 grid-margin stretch-card card-div">
                <div class="container">
                  <h5 class="mb-4">Edit Extend Order<br><b>{{$route.query.orderCode}}</b></h5>
                  <div v-if="dataExtend.length != 0">
                    <div class="product-title">
                      {{dataExtend[0].productTitle}} ({{dataExtend[0].conditionName}})
                    </div>
                    <div class="product-title mb-2">
                      {{dataExtend[0].specifications}}
                    </div>
                    <div class="row mb-1">
                      <div class="col-3">
                        <input type="text" name="" placeholder="Input Product Code/SN" class="form-control form-control-sm field-product-code" v-model="fieldFilterCode">
                        <!-- @keyup.enter="filterByCode(index,fieldFilterCode[index])"> -->
                      </div>
                      <div class="col-3">
                        <div class="d-flex align-items-center">
                          Set 
                          <input type="number" name="" class="form-control form-control-sm field-duration ml-2 mr-2" placeholder="Duration" v-model="fieldFilterDuration" @input="changeZerolValue(fieldFilterDuration,'filter')" min="1" @keypress="isNumber($event)"> Months 
                          <button class="btn btn-sm btn-primary ml-2" @click="updateMonth"> Update</button>
                          </div>
                      </div>
                      <div class="col-3">
                        <div class="d-flex align-items-center">
                          Set 
                          <input type="number" name="" class="form-control form-control-sm field-price ml-2 mr-2" placeholder="Price" v-model="fieldFilterPrice" @keypress="isNumber($event)">
                          <button class="btn btn-sm btn-primary" @click="updatePrice(dataExtend)"> Update</button>
                      </div>
                    </div>
                      <div class="col-3">
                        <input type="checkbox" id="1" @change="checkAll"> Check All
                      </div>
                    </div>
                    <table class="fixed_header table-bordered table-striped table-responsive-sm w-100 table-sm mb-3">
                        <tbody>
                            <tr>
                                <th>Product Code/Serial Number</th>
                                <th>Duration</th>
                                <th>Price</th>
                                <th>Item Removed</th>
                            </tr>
                            <tr v-for="(dataItem,idx) in filterByCode(fieldFilterCode)" :key="idx">
                                <td>{{dataItem.productCode}}/{{dataItem.serialNumber}}</td>
                                <td><input type="number" name="" v-model="dataItem.duration" style="width: 50px;" @keypress="isNumber($event)" min="1"> Months</td>
                                <td><input type="number" name="" v-model="dataItem.itemPrice" style="width: 100px;" @keypress="isNumber($event)" min="0"></td>
                                <td><input type="checkbox" :id="dataItem.orderDetailsId"  v-model="dataItem.checked" @change="checkOne(dataItem.orderDetailsId,dataItem)">
                                </td>
                            </tr>
                            <tr v-if="filterByCode(fieldFilterCode).length == 0">
                                <td colspan="4" class="text-center">Data Not Available</td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
                  <div class="row d-flex flex-row-reverse mr-1">
                    <button class="btn btn-sm btn-primary ml-2" @click="submitEditExtendOrder" :disabled="loadingButtonSave"><img src="~@/assets/images/2.gif" style="height: 18px;" v-if="loadingButtonSave"> save </button>
                    <button class="btn btn-sm btn-danger" @click="toDetail(orderId)"> cancel </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /#page-content-wrapper -->
      </div>
    </div>
  </template>

<script>
  import SideBar from '../SideBar'
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  export default {
    name: 'OrderPage',
    components:{
      SideBar,
      Multiselect
    },
    data () {
      return {
        orderId:'',
        dataExtend:[],
        fieldFilterCode:'',
        fieldFilterDuration:'',
        fieldFilterPrice:'',
        loadingButtonSave:false,
        productId:'',
        condition:'',
        duration:''
      }
    },
    computed:{
        
    },
    methods: {
      setMinimumValue(dataInput, orderDetailsId){
        if (dataInput == '') {
          for (var i = 0; i < this.dataExtend.length; i++) {
            if (this.dataExtend[i] == orderDetailsId) {
              this.dataExtend[i].duration = 1
            }
          }
        }
      },
      changeZerolValue(input,fieldType){
        if (input == '0' && fieldType == 'filter') {
          this.fieldFilterDuration = 1
        }
      },
      toDetail(id){
        this.$router.push({path:'/order/detail/' + id, query: {
              orderCode: this.$route.query.orderCode,
              companyIdDetail: this.$route.query.companyId
            }
        })
      },
      submitEditExtendOrder(){
          let sendApi = true
          for (var i = 0; i < this.dataExtend.length; i++) {
            if (this.dataExtend[i].duration === '' || this.dataExtend[i].itemPrice === '') {
              console.log('sorry '+ i)
              swal("Sorry", "Field must be fill" , "error", {
                  button: "Ok",
              })
              sendApi = false
            }
            if (this.dataExtend[i].duration === '0') {
              swal("Sorry", "Minimal duration 1 month" , "error", {
                  button: "Ok",
              })
              sendApi = false
            }
          }
          if (sendApi) {
            let self = this
            this.loadingButtonSave = true
            this.$http.post(process.env.EXTEND_EDIT_ITEM,{
              dataEdit: this.dataExtend,
              orderId: this.orderId,
              productId: this.productId,
              condition: this.condition,
              duration: this.duration,
            },
            {
              timeout: 30 * 1000,
              headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
              if (response.data.status == 400) {
                swal("Sorry", response.data.message, "error", {
                      button: "Ok",
                    })
              }else{
                if (response.data.status === 200) {
                    swal("Success", response.data.message , "success", {
                        button: "Ok",
                    }).then((value) => {
                      this.toDetail(this.orderId)
                    })
                }else if (response.data.status == 400) {
                    swal("Sorry", response.data.message , "error", {
                        button: "Ok",
                    })
                    this.handleLogout()
                }else if (response.data.status == 201) {
                    swal("Sorry", response.data.message , "error", {
                        button: "Ok",
                    })
                } 
              }
              this.loadingButtonSave = false
            })
            .catch(error => {
              if (!error.status) {
                  self.loadingButtonSave = false
                  self.getData()
                  alert('Request timeout / error with api, please try again!')
              }

              swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
              }).then(v => {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                }
              })
            })
          }
      },
      updatePrice(){
        if (this.fieldFilterPrice === '') {
          swal("Sorry", "Price must be fill", "error", {
                  button: "Ok",
          })
        }else{
          for (var i = 0; i < this.dataExtend.length; i++) {
            this.dataExtend[i].itemPrice = this.fieldFilterPrice
          }
          this.fieldFilterPrice = 0
          this.fieldFilterPrice = this.dataExtend[0].itemPrice
        }
        
      },
      updateMonth(){
        if (this.fieldFilterDuration === '') {
          swal("Sorry", "Duration must be fill", "error", {
                  button: "Ok",
          })
        }else{
          for (var i = 0; i < this.dataExtend.length; i++) {
            this.dataExtend[i].duration=this.fieldFilterDuration
          }
          this.fieldFilterDuration= 0
          this.fieldFilterDuration= this.dataExtend[0].duration
        }
      },
      checkOne(id,data){
        let checkAll = true
        for (var i = 0; i < this.dataExtend.length; i++) {
          if (this.dataExtend[i].checked === false) {
            checkAll = false
          }
        }
        if (checkAll === true) {
          document.getElementById("1").checked = true
        }else{
          document.getElementById("1").checked = false
        }
      },
      checkAll(data){
        if (document.getElementById("1").checked) {
          for (var i = 0; i < this.dataExtend.length; i++) {
            var myEle = document.getElementById(this.dataExtend[i].orderDetailsId);
            if(myEle){
                document.getElementById(this.dataExtend[i].orderDetailsId).checked=true
            }
            this.dataExtend[i].checked = true
          }
        }else{
          for (var i = 0; i < this.dataExtend.length; i++) {
            var myEle = document.getElementById(this.dataExtend[i].orderDetailsId);
            if(myEle){
                document.getElementById(this.dataExtend[i].orderDetailsId).checked=false
            }
            this.dataExtend[i].checked = false
          }
        }
      },
      filterByCode(productCode){
        if (productCode === '') {
          return this.dataExtend
        }else if (productCode != ''){
          return this.dataExtend.filter(function (el) {
            return el.productCode === productCode ||
                   el.serialNumber === productCode;
          });
        }
      },
      isNumber: function(evt) {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();
          } else {
            return true;
          }
      },
      sidebar(){
        $("#wrapper").toggleClass("toggled");
      },
      toPage(e) {
        this.$router.push(e)
      },
      toOrderPage(){
        this.$router.push({path:'/order', 
              query: {
                  companyName: '',
                  orderId: '',
                  statusOrder: JSON.stringify([]),
                  picId: '',
                  picName: '',
                  deliveDateFrom: '',
                  deliveDateTo: '',
                  pickupDateFrom: '',
                  pickupDateTo: '',
                  itemPerPage: 10,
                  page:1
              }
        })
      },
      openModal(x,y) {
        this.idxNote = y
        $("#modal"+x).modal('show')
      },
      async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
        localStorage.removeItem('jwt')
        localStorage.removeItem('admin_name')
        localStorage.removeItem('roles')
        localStorage.removeItem('user_email')
        localStorage.removeItem('admin_id')
        localStorage.removeItem('changeCatalogPermission')
        this.$router.push('/')
      },
      cekLogin(){
        if (localStorage.getItem('jwt') == null) {
          this.$router.push('/')
        }
      },
      getData(){
        this.loadingTable = true
        this.loadingTableOrder = true
        this.orderId = this.$route.params.orderId
        this.productId = this.$route.query.productId
        this.condition = this.$route.query.condition
        this.duration = this.$route.query.duration
        this.$http.post(process.env.GET_EXTEND_ITEM_EDIT,{
          orderId: this.orderId,
          productId: this.productId,
          condition: this.condition,
          duration: this.duration,
        },
        {
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
                  button: "Ok",
                })
          }else{
            this.dataExtend = response.data.content
            this.fieldFilterCode = ''
            this.fieldFilterPrice = this.dataExtend[0].itemPrice
            this.fieldFilterDuration = this.dataExtend[0].duration
            for (var i = 0; i < this.dataExtend.length; i++) {
                this.dataExtend[i] = {
                  productId: this.dataExtend[i].productId,
                  productTitle: this.dataExtend[i].productTitle,
                  productType: this.dataExtend[i].productType,
                  specifications: this.dataExtend[i].specifications,
                  condition: this.dataExtend[i].condition,
                  conditionName: this.dataExtend[i].conditionName,
                  duration:this.dataExtend[i].duration,
                  itemPrice:this.dataExtend[i].itemPrice,
                  orderDetailsId:this.dataExtend[i].orderDetailsId,
                  productCode:this.dataExtend[i].productCode,
                  serialNumber:this.dataExtend[i].serialNumber,
                  checked:false
                }
            }
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      },
      sendLog(x){
        var today = new Date();
        var month = today.getMonth()+1
        if (month < 10) {
            month = '0'+month
        }
        var dateDay = today.getDate()
        if (dateDay < 10) {
            dateDay = '0'+dateDay
        }
        var hours = today.getHours()
        if (hours < 10) {
            hours = '0'+hours
        }
        var minutes = today.getMinutes()
        if (minutes < 10) {
            minutes = '0'+minutes
        }
        var second = today.getSeconds()
        if (second < 10) {
            second = '0'+second
        }
        var date = today.getFullYear()+'-'+month+'-'+dateDay;
        var time = hours + ":" + minutes + ":" + second;
        var dateTime = date+' '+time;
        var admin = this.admin
        var command = 'add-logs'

        this.$http.post(process.env.LOG_URL+"/order/"+x,{
          codeLogs: 1,
          params: [],
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
        })
        .catch(error => {
          console.log(error)
        })
      }
    },
    created(){
      this.getData()
      this.admin = localStorage.getItem('admin_name')
      this.adminId = localStorage.getItem('admin_id')
      this.cekLogin()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .field-product-code{
    max-width: 180px;
  }
  .field-duration{
    max-width: 50px;
  }
  .field-price{
    max-width: 100px;
  }
  .product-title{
    font-weight: bold;
  }
  .fixed_header{
    table-layout: fixed;
    border-collapse: collapse;
  }

  .fixed_header tbody{
    display:block;
    overflow:auto;
    height:200px;
    width:100%;
  }

  .fixed_header tbody tr td{
    width:1578px;
  }

  .fixed_header thead tr{
    display:block;
  }

  .fixed_header th, .fixed_header td {
    padding: 5px;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderExtendEditPage.vue